/** @graphql cc **/

import gql from 'graphql-tag';

export const TasksQuery = gql`
	query TasksQuery($taskQuery: InlineTasksByMetadata!) {
		inlineTasks(tasksQuery: $taskQuery) {
			inlineTasks {
				id
				taskId
				status
				createdBy {
					accountId
					displayName
				}
				createdAt
				dueAt
				assignedTo {
					accountId
					displayName
					profilePicture {
						path
					}
				}
				body {
					adf
				}
				container {
					__typename
					... on ConfluencePage {
						id
						pageId
						links {
							base
							webUi
						}
						title
						space {
							id
							spaceId
							name
							links {
								base
								webUi
							}
						}
					}
					... on ConfluenceBlogPost {
						id
						blogPostId
						links {
							base
							webUi
						}
						title
						space {
							id
							spaceId
							name
							links {
								base
								webUi
							}
						}
					}
				}
			}
			endCursor
		}
	}
`;
